import { useRouter } from 'next/router';
import { type ReactNode, createContext, useEffect, useRef } from 'react';
import ROUTE_URLS from '@constants/routeUrls';

type NavigationContextType = {
  handleNavigationBack: () => void;
};

export const NavigationContext = createContext<NavigationContextType | null>(
  null
);

export const NavigationProvider = ({ children }: { children: ReactNode }) => {
  const router = useRouter();
  const isInitializedRef = useRef(false);
  const navStackRef = useRef<string[]>([]);

  useEffect(() => {
    if (navStackRef.current.length === 0) {
      navStackRef.current.push(router.asPath);
    }

    const handleRouteChange = (url: string) => {
      if (!isInitializedRef.current) {
        isInitializedRef.current = true;
        return;
      }

      const lastRoute = navStackRef.current[navStackRef.current.length - 1];
      if (lastRoute !== url) {
        navStackRef.current.push(url);
      }
    };

    router.events.on('routeChangeComplete', handleRouteChange);

    return () => {
      router.events.off('routeChangeComplete', handleRouteChange);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps -- FIXME
  }, [router.asPath]);

  const handleNavigationBack = () => {
    if (navStackRef.current.length > 1) {
      navStackRef.current.pop();
      router.back();
    } else {
      router.replace(ROUTE_URLS.HISTORY_ORDERS);
    }
  };

  return (
    <NavigationContext.Provider value={{ handleNavigationBack }}>
      {children}
    </NavigationContext.Provider>
  );
};
